export function calculateYield(rentPerWeek, price, discountPercent = 0) {
  if (!rentPerWeek || !price || rentPerWeek <= 0 || price <= 0) {
    return null
  }

  const adjustedPrice = price * (1 - discountPercent / 100)
  const annualRent = rentPerWeek * 52
  const yieldPercent = (annualRent / adjustedPrice) * 100

  return yieldPercent
}

export function formatYield(yieldPercent) {
  if (yieldPercent === null || yieldPercent === undefined) {
    return null
  }

  return `${yieldPercent.toFixed(2)}%`
}
